@if (!status) {
    <div class="navbar-info-message__height"></div>
    <div class="navbar-info-message bg-primary">
        <mat-icon fontIcon="warning" />
        <span role="alert" class="ms-2">{{ 'core.network_offline' | translate }}</span>
    </div>
}
